import { createContext } from 'react';
import { SurveyQuestion, SurveyResponseTagging } from '@/types';

export type QuestionTaggingBuilderState = {
  item: SurveyQuestion;
  updateQuestionResponseTagging: (data: SurveyResponseTagging[]) => unknown;
};

export const QuestionTaggingBuilderContext = createContext<QuestionTaggingBuilderState>(null!);